import { mapGetters } from 'vuex'
import api from '@/api'
import dayjs from 'dayjs'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import { shipping } from './shippingbase64.js'
import numeral from 'numeral'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'
import THBText from 'thai-baht-text'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}

export default {
  props: ['orders', 'circle'],
  data() {
    return {
      loadingarr: [],
      showExport: false,
      exportlimit: 50,
      exportpagecount: 0,
      profile: '',
      loading: false,
      loadingsave: false,
      showEditAddress: false,
      input: {
        pageaddress: ''
      },

      regularsize: 14,
      headersize: 18,
      size: ''
    }
  },
  components: {
    ShippingAddress
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      addresses: 'getShippingAddress'
    }),
    showPrice() {
      return [
        '148831989096546',
        '1229692217050821',
        '135565533158593',
        '488563718210335',
        '799590883441878',
        '131518260361809'
      ].includes(this.selectedBot.pageid)
    }
  },
  methods: {
    onExportCustomer() {
      this.exportpagecount = Math.ceil(this.orders.length / this.exportlimit)
      if (this.exportpagecount >= 1) {
        this.showExport = true
      }
    },
    saveContent() {
      let vm = this
      this.showEditAddress = false
      this.getShopProfile()
      // vm.loadingsave = true
      // api.editShopProfile({ ...this.getPageProfile, pageaddress: this.input.pageaddress }, function(
      //   error,
      //   response
      // ) {
      //   vm.loadingsave = false

      //   if (error) {
      //     console.error(error)
      //     return
      //   }
      //   vm.$store.state.pageProfile.pageaddress = vm.input.pageaddress
      //   vm.getShopProfile()
      //   vm.showEditAddress = false
      // })
    },
    cancelEdit() {
      this.showEditAddress = false
      this.input.pageaddress = ''
    },
    skipEdit() {
      this.showEditAddress = false
      this.input.pageaddress = ''
      this.profile = {
        companyname: '',
        phoneno: '',
        pageaddress: ''
      }
      var vm = this
      vm.$emit('onPrinCover', {
        printPdf: function(orders) {
          var pageSetting = vm.getDocumentFormat(vm.size)
          vm.printPDF(orders, pageSetting)
        }
      })
    },
    clickPrintPdf() {
      if (this.getPageProfile.pageaddress || (this.addresses && this.addresses.length > 0)) {
        this.getShopProfile()
      } else {
        this.showEditAddress = true
      }
    },
    getShopProfile: async function(size = 'a5', page = 1) {
      const vm = this
      // let selected = vm.orders.filter(el => {
      //   return el
      //   // ['paid'].includes(el.status)
      // })
      // if (selected.length == 0) {
      //   await vm.$swal({
      //     title: 'โปรดเปลี่ยนสถานะออเดอร์เป็น "จ่ายแล้ว" เพื่อดำเนินการต่อ',
      //     type: 'warning',
      //     confirmButtonText: vm.$t('Confirm')
      //   })
      // } else {
      let arrayid = []
      this.orders.map((item, index) => {
        if (index >= (page - 1) * vm.exportlimit && index <= page * vm.exportlimit - 1) {
          arrayid.push(item.id)
        }
      })

      const orderSelect = arrayid.toString()

      vm.$set(vm.loadingarr, page, true)
      if (!vm.selectedBot.pageid || vm.selectedBot.pageid == null) {
        return false
      }
      vm.size = size

      if (vm.addresses && vm.addresses.length > 0) {
        let address = vm.addresses.find(el => {
          return el.selected
        })
        vm.profile = {
          companyname: address.name,
          phoneno: address.tel,
          pageaddress:
            address.addressno +
            ' , ' +
            address.sub_district +
            ' , ' +
            address.district +
            ' , ' +
            address.province +
            ' , ' +
            address.postcode
        }
        vm.$emit('onPrinCover', {
          printPdf: function(orders) {
            let pageSetting = vm.getDocumentFormat(vm.size)
            vm.printPDF(orders, pageSetting, page)
          },
          orderSelect
        })
      } else if (vm.getPageProfile.pageaddress) {
        await vm.getShopAddress()
        vm.$emit('onPrinCover', {
          printPdf: function(orders) {
            let pageSetting = vm.getDocumentFormat(vm.size)
            vm.printPDF(orders, pageSetting, page)
          },
          orderSelect
        })
      } else {
        if (vm.size == 'billing') {
          vm.$emit('onPrinCover', {
            printPdf: function(orders) {
              let pageSetting = vm.getDocumentFormat(vm.size)
              vm.printPDF(orders, pageSetting, page)
            },
            orderSelect
          })
        } else {
          vm.showEditAddress = true
        }
      }
     
      await vm.post(`order/${vm.selectedBot.pageid}/stamp-print-cover`, {
        order_ids: arrayid
      })
      // }
    },
    getShopAddress() {
      var vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        let auth = null
        api.getShopProfile(data, function(error, response) {
          if (error) {
            console.error(error)
            reject()
            return
          }
          // console.log(response)
          if (response.shopprofile) {
            vm.profile = response.shopprofile
            try {
              vm.profile.companyname = JSON.parse(response.shopprofile.description).companyname
              vm.profile.phoneno = JSON.parse(response.shopprofile.description).phoneno
            } catch (error) {
              vm.profile.companyname = ''
              vm.profile.phoneno = ''
            }
            resolve()
            // console.log(vm.profile)
            // console.log(response.shopprofile.descriptio)
          }
        })
      })
    },
    async myShippingImg() {
      // var shipping = {
      //   flash_charge: '',
      //   additionalproduct_charge: '',
      //   nim_charge: '',
      //   ninjavan_charge: '',
      //   jtexpress_charge: '',
      //   lalamove_charge: '',
      //   cjlogistics_charge: '',
      //   nikos_charge: '',
      //   scgexpress_charge: '',
      //   skootar_charge: '',
      //   alphaexpress_charge: '',
      //   deliveree_charge: '',
      //   grab_charge: '',
      //   lineman_charge: '',
      //   tnt_charge: '',
      //   cod_charge: '',
      //   normal_charge: '',
      //   ems_charge: '',
      //   kerry_charge: '',
      //   bestexpress_charge: '',
      //   interexpress_charge: '',
      //   dhl_charge: '',
      //   other_charge: '',
      //   other2_charge: '',
      //   other3_charge: '',
      //   other4_charge: '',
      //   other5_charge: ''
      // }
      // return new Promise(async (resolve, reject) => {
      //   for (var item in shipping) {
      //     shipping[item] = await this.getBase64Image(
      //       'https://' +
      //         window.location.host +
      //         '/static/img/assets/payment/mini/' +
      //         (item.includes('other') ? 'other_charge' : item) +
      //         '_logo.jpg'
      //     )
      //   }
      //   return resolve(shipping)
      // })

      return Promise.resolve(shipping)
    },
    getBase64Image(url) {
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        xhr.onload = function() {
          var reader = new FileReader()
          reader.onloadend = function() {
            resolve(reader.result)
          }
          reader.readAsDataURL(xhr.response)
        }
        xhr.onerror = function(e) {
          reject(e)
        }
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.send()
      })
    },
    async formatTemplate(orders) {
      var shippinglist = this.$store.state.shippinglist
      var vm = this

      var shippingtypeimg = await this.myShippingImg()
      var data
      if (this.size == 'billing') {
        data = orders.map((el, i) => {
          var productdetail

          var formatproductdetail = []
          try {
            productdetail = JSON.parse(el.productdetail)
            productdetail = productdetail.sort((a, b) => {
              return a.name.localeCompare(b.name)
            })
            formatproductdetail = productdetail.map((val, i) => {
              return [
                {
                  text: `${i + 1}. ${val.name} (${val.option}) ${
                    val.sku && val.sku !== '' ? `(${val.sku})` : ''
                  }`,
                  style: { fontSize: 15 },
                  bold: true
                },
                {
                  text: ' x' + val.quantity,
                  style: { fontSize: 15 },
                  bold: true,
                  alignment: 'right'
                }
              ]
            })
          } catch (error) {
            console.log(error)
            productdetail = []
            formatproductdetail = [{ text: el.productdetail }]
          }

          var shipping_date = el.shipping_date
            ? dayjs(el.shipping_date).format('DD/MM/YYYY (ddd)')
            : ''

          var order = [
            {
              text: `Order No. ${el.id}\n`,
              style: {
                bold: true,
                fontSize: 15
              }
            },
            {
              text: this.$t(
                el.shippingtype && el.shippingtype.includes('other')
                  ? shippinglist[el.shippingtype]
                    ? shippinglist[el.shippingtype][4]
                    : el.shippingtype
                  : el.shippingtype
              ),
              style: {
                bold: true,
                fontSize: 15
              }
            },
            {
              text: `วันที่ ${shipping_date}\n`,
              style: {
                bold: true,
                fontSize: 15,
                margin: [0, 20, 0, 0]
              }
            },
            {
              text: `หมายเหตุ`,
              style: {
                bold: true,
                fontSize: 15
              },
              margin: [0, 20, 0, 0]
            },
            {
              text: `${el.remark} \n`,
              style: {
                bold: true,
                fontSize: 13
              }
            },
            {
              text: `ชื่อ ${vm.noSpaceAndSpecial(el.nameaddress)} \n`,
              style: {
                bold: true,
                fontSize: 15
              },
              margin: [0, 20, 0, 0]
            },
            {
              text: `รายการสินค้า`,
              style: {
                bold: true,
                fontSize: 15
              },
              margin: [0, 20, 0, 0]
            },
            {
              table: {
                body: formatproductdetail,
                widths: ['*', 'auto']
              },
              layout: {
                vLineWidth: function(i, node) {
                  return 0
                },
                hLineWidth: function(i, node) {
                  return 0
                }
              }
            },
            {
              text: 'ผู้จัดของ.....................................',
              style: {
                bold: true,
                fontSize: 15
              },
              margin: [0, 20, 0, 0]
            }
          ]

          if (i != orders.length - 1)
            order.push({
              text: '',
              pageBreak: 'after'
            })

          return order
        })
      } else if (this.size == 'central') {
        data = await Promise.all(
          orders.map(async (el, i) => {
            var productdetail

            var formatproductdetail = []
            try {
              productdetail = JSON.parse(el.productdetail)
              productdetail = productdetail.sort((a, b) => {
                return a.name.localeCompare(b.name)
              })
              formatproductdetail = await Promise.all(
                productdetail.map(async (val, i) => {
                  // console.log(await vm.getBase64ImageFromURL(val.photourl))
                  return [
                    [
                      {
                        text: `${val.name}${val.option} ${
                          val.sku && val.sku !== '' ? `(${val.sku})` : ''
                        }`,
                        bold: false,
                        fontSize: 11
                      },
                      await vm.getBase64ImageFromURL(
                        'https://zwiz.ai/web/public/img/enterprise/clients/central.png'
                      )
                    ],
                    {
                      text: val.sku,
                      bold: false,
                      fontSize: 11
                    },
                    {
                      text: val.priceperunit,
                      alignment: 'center',
                      bold: false,
                      fontSize: 11
                    },
                    {
                      text: val.quantity,
                      alignment: 'center',
                      bold: false,
                      fontSize: 11
                    },
                    {
                      text: numeral(val.price).format('0,0.00'),
                      alignment: 'center',
                      fontSize: 11
                    }
                  ]
                })
              )
            } catch (error) {
              console.log(error)
              productdetail = []
              formatproductdetail = [{ text: el.productdetail }]
            }

            return [
              {
                alignment: 'justify',
                columns: [
                  {
                    text: '',
                    bold: true
                  },
                  {
                    text: 'QUOTATION',
                    bold: true,
                    alignment: 'center',
                    style: 'header'
                  },
                  {
                    text: `Order Ref. ${el.id}`,
                    fontSize: 9,
                    bold: false,
                    alignment: 'right'
                  }
                ],
                margin: [0, 0, 0, 5]
              },
              {
                alignment: 'justify',
                columns: [
                  {
                    text: `Date: ${dayjs(el.timestamp).format('DD/MM/YYYY')} \n เรียน คุณ ${
                      el.first_name
                    } ${el.last_name}`,
                    bold: false,
                    fontSize: 11
                  },
                  {
                    text: `Payment status: ${el.status} \n Payment Method: ${el.payment}`,
                    bold: false,
                    fontSize: 11
                  },
                  {
                    image:
                      'data:image/jpeg;base64,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',
                    width: 120,
                    alignment: 'center'
                  }
                ],
                margin: [0, 0, 0, 5]
              },
              {
                columns: [
                  {
                    text: 'รายการสินค้าที่เสนอราคา',
                    bold: true,
                    fontSize: 11
                  },
                  {
                    text: ''
                  },
                  {
                    // text: 'หมายเลข The 1 Card 999999',
                    text: '',
                    bold: true
                  }
                ]
              },
              {
                style: 'tableExample',
                table: {
                  widths: [180, 40, '*', 25, '*'],
                  body: [
                    [
                      { text: 'รายละเอียดสินค้า', alignment: 'center', bold: true, fontSize: 11 },
                      { text: 'SKU', alignment: 'center', bold: true, fontSize: 11 },
                      { text: 'ราคาต่อหน่วย\n(รวม VAT)', bold: true, fontSize: 11 },
                      { text: 'จำนวน', bold: true, fontSize: 11 },
                      {
                        text: 'รวมทั้งสิ้น\n(รวม VAT)',
                        alignment: 'center',
                        bold: true,
                        fontSize: 11
                      }
                    ],
                    // [
                    //   'fixed-width cells have exactly the specified width',
                    //   { text: 'nothing interesting here', color: 'gray' },
                    //   { text: 'nothing interesting here', color: 'gray' },
                    //   { text: '1', color: 'gray' },
                    //   { text: '0.00', color: 'gray' },
                    //   { text: 'nothing interesting here', color: 'gray' }
                    // ],
                    ...formatproductdetail
                    // [
                    //   '( แปดร้อยเก้าสิบบาทถ้วน )',
                    //   '',
                    //   '',
                    //   '',
                    //   '',
                    //   'รวมค่าสินค้า  890.00\nค่าจัดส่ง  0.00\nราคารวม  890.00'
                    // ]
                  ]
                }
              },
              {
                style: 'tableExample',
                table: {
                  widths: ['*'],
                  body: [
                    // [
                    //   '( แปดร้อยเก้าสิบบาทถ้วน )                                                            รวมค่าสินค้า  890.00 \n ค่าจัดส่ง      0.00'
                    // ]
                    [
                      {
                        // alignment: 'justify',
                        // columns: [
                        // {
                        layout: 'lightHorizontalLines',
                        table: {
                          widths: [250, '*', '*'],
                          body: [
                            [
                              {
                                stack: [
                                  {
                                    text: `( ${THBText(el.amount)} )`,
                                    margin: [0, 0, 0, 0],
                                    fontSize: 11
                                  },
                                  { text: '', margin: [0, 0, 0, 0] },
                                  { text: '', margin: [0, 0, 0, 0] },
                                  { text: '', margin: [0, 0, 0, 0] },
                                  { text: '', margin: [0, 0, 0, 0] }
                                ]
                              },
                              {
                                stack: [
                                  {
                                    text: 'ราคาสินค้า',
                                    margin: [0, 0, 0, 0],
                                    alignment: 'left',
                                    bold: true,
                                    fontSize: 11
                                  },
                                  {
                                    text: 'ค่าจัดส่ง',
                                    margin: [0, 0, 0, 0],
                                    alignment: 'left',
                                    bold: true,
                                    fontSize: 11
                                  },
                                  {
                                    text: 'ส่วนลด',
                                    margin: [0, 0, 0, 0],
                                    alignment: 'left',
                                    bold: true,
                                    fontSize: 11
                                  },
                                  {
                                    text: 'ราคารวม',
                                    margin: [0, 0, 0, 0],
                                    alignment: 'left',
                                    bold: true,
                                    fontSize: 11
                                  }
                                ]
                              },
                              {
                                stack: [
                                  {
                                    text: numeral(el.total).format('0,0.00'),
                                    margin: [0, 0, 0, 0],
                                    alignment: 'right',
                                    fontSize: 11
                                  },
                                  {
                                    text: numeral(el.shippingcharge).format('0,0.00'),
                                    margin: [0, 0, 0, 0],
                                    alignment: 'right',
                                    fontSize: 11
                                  },
                                  {
                                    text: numeral(el.discount).format('0,0.00'),
                                    margin: [0, 0, 0, 0],
                                    alignment: 'right',
                                    fontSize: 11
                                  },
                                  {
                                    text: numeral(el.amount).format('0,0.00'),
                                    margin: [0, 0, 0, 0],
                                    alignment: 'right',
                                    fontSize: 11
                                  }
                                ]
                              }
                            ]
                          ]
                        }
                      }
                    ]
                  ],
                  margin: [0, 0, 0, 0]
                  // }
                  // ]
                }
              },

              {
                text: 'สถานที่จัดส่ง :',
                style: { fontSize: 11 },
                margin: [0, 10, 0, 0],
                bold: true
              },
              {
                text: `ชื่อ/ที่อยู่ : ${el.nameaddress}`,
                margin: [10, 0, 0, 0],
                fontSize: 11
              },
              {
                text:
                  'สำหรับออกใบกำกับภาษีเต็มรูป :               🔲 ต้องการ                🔲 ไม่ต้องการ',
                fontSize: 11,
                bold: true
              },
              {
                text:
                  'ชื่อ :_____________________________________________________________________________________________',
                margin: [10, 0, 0, 0],
                fontSize: 11
              },
              {
                text:
                  'ที่อยู่ :____________________________________________________________________________________________',
                margin: [10, 0, 0, 0],
                fontSize: 11
              },
              {
                text: 'เงื่อนไขการจองสินค้า / จัดส่งสินค้า',
                fontSize: 11,
                bold: true
              },
              {
                text:
                  '____________________________________________________________________________________________\n____________________________________________________________________________________________'
              },
              '\n',
              {
                alignment: 'left',
                columns: [
                  {
                    width: '30%',
                    text: 'Barcode',
                    bold: false
                  },
                  [
                    {
                      text: 'CHECK BY',
                      bold: true
                    },
                    {
                      style: 'tableExample',
                      table: {
                        heights: [2, 2],
                        widths: [60, 60],
                        body: [
                          [
                            { text: 'PC/BA', fontSize: 9, fillColor: '#CCCCCC' },
                            { text: 'PC/BA', fontSize: 9, fillColor: '#CCCCCC' }
                          ],
                          [
                            { text: ' ', fontSize: 9 },
                            { text: ' ', fontSize: 9 }
                          ],
                          [
                            { text: 'Checker', fontSize: 9, fillColor: '#CCCCCC' },
                            { text: 'Packer', fontSize: 9, fillColor: '#CCCCCC' }
                          ],
                          [
                            { text: ' ', fontSize: 9 },
                            { text: ' ', fontSize: 9 }
                          ]
                        ]
                      }
                    }
                  ],
                  [
                    {
                      width: '30%',
                      text: 'ขอแสดงความนับถือ',
                      alignment: 'center',
                      fontSize: 11
                    },
                    {
                      width: '30%',
                      text: 'บริษัท สรรพสินค้าเซ็นทรัล จำกัด',
                      alignment: 'center',
                      fontSize: 11
                    }
                  ]
                ],
                margin: [0, 0, 0, 5]
              }
            ]
          })
        )
      } else if (this.size == 'new-a5') {
        data = orders.map((el, i) => {
          var productdetail

          var payment = vm.$t('Credit card')
          if (el.payment == 'banktransfer' || el.payment == 'transfer') {
            payment = vm.$t('Bank Transfer')
          } else if (el.payment == 'qrcode') {
            payment = 'Qr Code'
          } else if (el.payment == 'fbpay') {
            payment = vm.$t('Mobile Banking')
          } else if (el.payment == 'cod') {
            payment = vm.$t('cod_charge')
          }
          var formatproductdetail = []
          try {
            productdetail = JSON.parse(el.productdetail)
            productdetail = productdetail.sort((a, b) => {
              return a.name.localeCompare(b.name)
            })
            formatproductdetail = productdetail.map((val, i) => {
              return [
                {
                  text: i + 1,
                  style: { fontSize: vm.regularsize },
                  bold: true,
                  alignment: 'center'
                },
                {
                  text: `${val.name} ${val.sku && val.sku !== '' ? `(${val.sku})` : ''}`,
                  style: { fontSize: vm.regularsize },
                  bold: true
                },
                {
                  text: val.option,
                  style: { fontSize: vm.regularsize },
                  alignment: 'center',
                  bold: true
                },
                {
                  text: val.quantity,
                  style: { fontSize: vm.regularsize },
                  alignment: 'center',
                  bold: true
                }
              ]
            })
          } catch (error) {
            console.log(error)
            productdetail = []
            formatproductdetail = [{ text: el.productdetail }]
          }

          return [
            {
              // width: 225,
              table: {
                widths: ['*'],
                heights: [60],
                body: [
                  [
                    {
                      text: [
                        { text: vm.$t('Sender') + '\n' },
                        {
                          text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                            vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                          } ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                          style: 'paragraph',
                          bold: true
                        }
                      ],
                      style: 'container',
                      lineHeight: 1
                    }
                  ]
                ]
              }
            },
            {
              margin: [0, 6, 0, 0],
              table: {
                widths: ['60%', '40%'],
                heights: [120],
                body: [
                  [
                    {
                      margin: [0, 0, 20, 0],
                      text: [
                        { text: vm.$t('Receiver') + '\n', style: 'header' },
                        {
                          text: vm.noSpaceAndSpecial(el.nameaddress),
                          style: 'paragraph',
                          bold: true,
                          fontSize: 20
                        }
                      ],
                      style: 'container'
                    },
                    {
                      text: [
                        {
                          text: 'เก็บเงินค่าสินค้า (บาท)\n',
                          fontSize: 20,
                          bold: true,
                          alignment: 'center'
                        },
                        {
                          text: el.payment == 'cod' ? el.amount : 'ไม่เก็บเงิน',
                          bold: true,
                          alignment: 'center',
                          fontSize: 30
                        }
                      ]
                    }
                  ]
                ]
              }
            },
            {
              text: 'ใบเสร็จรับเงิน',
              style: 'receipt',
              margin: [0, 10, 0, 5]
            },
            {
              table: {
                widths: ['*', '40%'],
                lineHeight: 0.5,
                body: [
                  [
                    {
                      text: `${vm.$t('Order No:')} ${el.id}`,
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      border: [true, true, false, true]
                    },
                    {
                      text: `${vm.$t('Date: ')} ${dayjs(el.timestamp).format('DD/MM/YYYY')}`,
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      border: [false, true, true, true]
                    }
                  ],
                  [
                    {
                      text: `${vm.$t('Shipping option')} ${vm.$t(
                        el.shippingtype && el.shippingtype.includes('other')
                          ? shippinglist[el.shippingtype]
                            ? shippinglist[el.shippingtype][4]
                            : el.shippingtype
                          : el.shippingtype
                      )}`,
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      border: [true, true, false, true]
                    },
                    {
                      text: `${vm.$t('Payment Method')} ${payment}`,
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      border: [false, true, true, true]
                    }
                  ]
                ]
              }
            },
            {
              table: {
                widths: ['auto', '*', '20%', '20%'],
                body: [
                  [
                    {
                      text: 'ลำดับ',
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      alignment: 'center'
                    },
                    {
                      text: 'รายการ',
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: 'ตัวเลือก',
                      style: { fontSize: vm.regularsize },
                      alignment: 'center',
                      bold: true
                    },
                    {
                      text: 'จำนวน',
                      style: { fontSize: vm.regularsize },
                      alignment: 'center',
                      bold: true
                    }
                  ],
                  ...formatproductdetail,
                  [
                    {
                      rowSpan: 4,
                      colSpan: 2,
                      text: [
                        {
                          text: `${vm.$t('Remark')}`
                        },
                        {
                          text:
                            el.remark != null &&
                            [
                              '148831989096546',
                              '1229692217050821',
                              '135565533158593',
                              '488563718210335',
                              '799590883441878'
                            ].includes(vm.selectedBot.pageid)
                              ? el.remark.split(';;')[0]
                              : el.remark
                        }
                      ]
                    },
                    {},
                    { text: `ยอดรวม`, border: [true, true, false, true] },
                    {
                      text: el.total,
                      alignment: 'right',
                      border: [false, true, true, true]
                    }
                  ],
                  [
                    {},
                    {},
                    { text: `ค่าขนส่ง`, border: [true, true, false, true] },
                    {
                      text: el.shippingcharge,
                      alignment: 'right',
                      border: [false, true, true, true]
                    }
                  ],
                  [
                    {},
                    {},
                    { text: `ส่วนลด`, border: [true, true, false, true] },
                    {
                      text: el.discount,
                      alignment: 'right',
                      border: [false, true, true, true]
                    }
                  ],
                  [
                    {},
                    {},
                    { text: `ยอดรวมทั้งหมด`, border: [true, true, false, true] },
                    {
                      text: el.amount,
                      alignment: 'right',
                      border: [false, true, true, true]
                    }
                  ]
                ]
              },
              pageBreak: i + 1 == orders.length ? '' : 'after'
            }
          ]
        })
      } else if (this.size == 'a4') {
        data = orders.map((el, i) => {
          var receiver_address = vm.noSpaceAndSpecial(el.nameaddress)
          let receiver_tel = ''
          if (receiver_address && receiver_address.match(/[0]([0-9]){9,12}/g)) {
            receiver_tel = receiver_address.match(/[0]([0-9]){9,12}/g)
            receiver_tel = receiver_tel[receiver_tel.length - 1]
          }

          var productdetail
          var payment = vm.$t('Credit card')
          if (el.payment == 'banktransfer' || el.payment == 'transfer') {
            payment = vm.$t('Bank Transfer')
          } else if (el.payment == 'qrcode') {
            payment = 'Qr Code'
          } else if (el.payment == 'fbpay') {
            payment = vm.$t('Mobile Banking')
          } else if (el.payment == 'cod') {
            payment = vm.$t('cod_charge')
          }
          var formatproductdetail = []
          try {
            productdetail = JSON.parse(el.productdetail)
            productdetail = productdetail.sort((a, b) => {
              return a.name.localeCompare(b.name)
            })
            formatproductdetail = productdetail.map((val, i) => {
              return [
                {
                  text: i + 1,
                  style: { fontSize: vm.regularsize },
                  bold: true,
                  alignment: 'center'
                },
                {
                  text: `${val.name} ${val.sku && val.sku !== '' ? `(${val.sku})` : ''}`,
                  style: { fontSize: vm.regularsize },
                  bold: true
                },
                {
                  text: val.option,
                  style: { fontSize: vm.regularsize },
                  alignment: 'center',
                  bold: true
                },
                {
                  text: val.quantity,
                  style: { fontSize: vm.regularsize },
                  alignment: 'center',
                  bold: true
                },
                {
                  text: numeral(val.price).format('0,0.00'),
                  style: { fontSize: vm.regularsize },
                  alignment: 'center'
                }
              ]
            })
          } catch (error) {
            console.log(error)
            productdetail = []
            formatproductdetail = [{ text: el.productdetail }]
          }

          return [
            {
              columns: [
                {
                  width: '40%',
                  table: {
                    widths: ['*', '*'],
                    heights: ['auto', 150, 'auto'],
                    body: [
                      [
                        {
                          text: vm.$t('Sender') + '\n',
                          border: [true, true, false, true]
                        },
                        {
                          text: vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno : '',
                          alignment: 'right',
                          border: [false, true, true, true]
                        }
                      ],
                      [
                        {
                          colSpan: 2,
                          text: [
                            {
                              text: `${
                                vm.profile.companyname ? vm.profile.companyname + ', ' : ''
                              } \n ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                              style: 'paragraph',
                              bold: true
                            }
                          ],
                          style: 'container',
                          lineHeight: 1
                        },
                        {}
                      ],
                      [
                        {
                          margin: [0, 10, 0, 0],
                          colSpan: 2,
                          image: shippingtypeimg[el.shippingtype]
                            ? shippingtypeimg[el.shippingtype]
                            : shippingtypeimg['other_charge'],
                          width: 100,
                          style: {
                            alignment: 'center',
                            fontSize: vm.regularsize - 3
                          },
                          border: [false, false, false, false]
                        },
                        {}
                      ]
                    ]
                  }
                },
                {
                  margin: [5, 0, 0, 0],
                  table: {
                    widths: ['40%', '55%'],
                    heights: ['auto', 150, 100],

                    body: [
                      [
                        {
                          text: vm.$t('Receiver'),
                          style: 'header',
                          border: [true, true, false, true]
                        },
                        {
                          text: receiver_tel,
                          style: 'header',
                          alignment: 'right',
                          border: [false, true, true, true]
                        }
                      ],
                      [
                        {
                          colSpan: 2,
                          margin: [0, 0, 20, 0],
                          text: [
                            {
                              text: vm.noSpaceAndSpecial(el.nameaddress),
                              style: 'paragraph',
                              bold: true,
                              fontSize: 20
                            }
                          ],
                          style: 'container'
                        },
                        {}
                      ],
                      [
                        {
                          colSpan: 2,
                          text: [
                            {
                              text: 'เก็บเงินค่าสินค้า (บาท)\n',
                              fontSize: 20,
                              bold: true,
                              alignment: 'center'
                            },
                            {
                              text: el.payment == 'cod' ? el.amount : 'ไม่เก็บเงิน',
                              bold: true,
                              alignment: 'center',
                              fontSize: 30
                            }
                          ]
                        },
                        {}
                      ]
                    ]
                  }
                }
              ]
            },
            {
              canvas: [
                {
                  type: 'line',
                  x1: -20,
                  y1: 0,
                  x2: 615,
                  y2: 0,
                  lineWidth: 1,
                  dash: { length: 5, space: 5 }
                }
              ],
              margin: [0, 30, 0, 10]
            },
            {
              text: 'ใบเสร็จรับเงิน',
              style: 'receipt',
              margin: [0, 10, 0, 5]
            },
            {
              table: {
                widths: ['*', '40%'],
                lineHeight: 0.5,
                body: [
                  [
                    {
                      text: `${vm.$t('Order No:')} ${el.id}`,
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      border: [true, true, false, true]
                    },
                    {
                      text: `${vm.$t('Date: ')} ${dayjs(el.timestamp).format('DD/MM/YYYY')}`,
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      border: [false, true, true, true]
                    }
                  ],
                  [
                    {
                      text: `${vm.$t('Shipping option')} ${vm.$t(
                        el.shippingtype && el.shippingtype.includes('other')
                          ? shippinglist[el.shippingtype]
                            ? shippinglist[el.shippingtype][4]
                            : el.shippingtype
                          : el.shippingtype
                      )}`,
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      border: [true, true, false, true]
                    },
                    {
                      text: `${vm.$t('Payment Method')} ${payment}`,
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      border: [false, true, true, true]
                    }
                  ]
                ]
              }
            },
            {
              table: {
                widths: ['auto', '*', '15%', '15%', '15%'],
                body: [
                  [
                    {
                      text: 'ลำดับ',
                      style: { fontSize: vm.regularsize },
                      bold: true,
                      alignment: 'center'
                    },
                    {
                      text: 'รายการ',
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: 'ตัวเลือก',
                      style: { fontSize: vm.regularsize },
                      alignment: 'center',
                      bold: true
                    },
                    {
                      text: 'จำนวน',
                      style: { fontSize: vm.regularsize },
                      alignment: 'center',
                      bold: true
                    },
                    {
                      text: 'ราคารวม',
                      style: { fontSize: vm.regularsize },
                      alignment: 'center',
                      bold: true
                    }
                  ],
                  ...formatproductdetail,
                  [
                    {
                      rowSpan: 4,
                      colSpan: 3,
                      text: [
                        {
                          text: `${vm.$t('Remark')}`
                        },
                        {
                          text:
                            el.remark != null &&
                            [
                              '148831989096546',
                              '1229692217050821',
                              '135565533158593',
                              '488563718210335',
                              '799590883441878'
                            ].includes(vm.selectedBot.pageid)
                              ? el.remark.split(';;')[0]
                              : el.remark
                        }
                      ]
                    },
                    {},
                    {},
                    { text: `ยอดรวม`, border: [true, true, false, true] },
                    {
                      text: el.total,
                      alignment: 'right',
                      border: [false, true, true, true]
                    }
                  ],
                  [
                    {},
                    {},
                    {},
                    { text: `ค่าขนส่ง`, border: [true, true, false, true] },
                    {
                      text: el.shippingcharge,
                      alignment: 'right',
                      border: [false, true, true, true]
                    }
                  ],
                  [
                    {},
                    {},
                    {},
                    { text: `ส่วนลด`, border: [true, true, false, true] },
                    {
                      text: el.discount,
                      alignment: 'right',
                      border: [false, true, true, true]
                    }
                  ],
                  [
                    {},
                    {},
                    {},
                    { text: `ยอดรวมทั้งหมด`, border: [true, true, false, true] },
                    {
                      text: el.amount,
                      alignment: 'right',
                      border: [false, true, true, true]
                    }
                  ]
                ]
              },
              pageBreak: i + 1 == orders.length ? '' : 'after'
            }
          ]
        })
      } else if (['5.7mm', '5.7mm-detail'].includes(this.size)) {
        data = orders.map((el, i) => {
          var receiver_address = vm.noSpaceAndSpecial(el.nameaddress)
          let receiver_tel = ''
          if (receiver_address && receiver_address.match(/[0]([0-9]){9,12}/g)) {
            receiver_tel = receiver_address.match(/[0]([0-9]){9,12}/g)
            receiver_tel = receiver_tel[receiver_tel.length - 1]
          }

          var productdetail
          var payment = vm.$t('Credit card')
          if (el.payment == 'banktransfer' || el.payment == 'transfer') {
            payment = vm.$t('Bank Transfer')
          } else if (el.payment == 'qrcode') {
            payment = 'Qr Code'
          } else if (el.payment == 'fbpay') {
            payment = vm.$t('Mobile Banking')
          } else if (el.payment == 'cod') {
            payment = vm.$t('cod_charge')
          }
          var formatproductdetail = []
          try {
            productdetail = JSON.parse(el.productdetail)
            productdetail = productdetail.sort((a, b) => {
              return a.name.localeCompare(b.name)
            })
            formatproductdetail = productdetail.map((val, i) => {
              return [
                {
                  text: `${i + 1}. ${val.name} ${val.option} ${
                    val.sku && val.sku !== '' ? `(${val.sku})` : ''
                  }`,
                  lineHeight: 1,
                  bold: true,
                  alignment: 'center'
                },
                {
                  text: `x ${val.quantity}`,
                  lineHeight: 1,
                  alignment: 'right',
                  bold: true
                }
              ]
            })
          } catch (error) {
            console.log(error)
            productdetail = []
            formatproductdetail = [{ text: el.productdetail }]
          }

          return [
            {
              table: {
                widths: ['*', 'auto'],
                body: [
                  [
                    { text: vm.$t('Sender') + '\n' },
                    {
                      text: vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno : '',
                      alignment: 'right'
                    }
                  ],
                  [
                    {
                      colSpan: 2,
                      text: [
                        {
                          text: `${
                            vm.profile.companyname ? vm.profile.companyname + ', ' : ''
                          } \n ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                          style: 'paragraph',
                          bold: true
                        }
                      ],
                      style: 'container',
                      lineHeight: 1
                    },
                    {}
                  ]
                ]
              }
            },
            {
              margin: [0, 5, 0, 0],
              table: {
                widths: ['45%','55%'],
                body: [
                  [
                    { text: vm.$t('Receiver') },
                    { text: `Tel. ${receiver_tel}`, alignment: 'right' }
                  ],
                  [
                    {
                      colSpan: 2,
                      margin: [0, 0, 10, 0],
                      text: [
                        {
                          text: vm.noSpaceAndSpecial(el.nameaddress),
                          style: 'paragraph',
                          bold: true
                        }
                      ]
                    },
                    {}
                  ],
                  [
                    {
                      colSpan: 2,
                      text: [
                        {
                          text: 'เก็บเงินค่าสินค้า (บาท)\n ',
                          bold: true,
                          fontSize: 10,
                          alignment: 'center'
                        },
                        {
                          text: el.payment == 'cod' ? el.amount : 'ไม่เก็บเงิน',
                          bold: true,
                          alignment: 'center'
                        }
                      ]
                    },
                    {}
                  ]
                ]
              }
            },
            {
              text: `${vm.$t('Order No:')} ${el.id}`,
              bold: true,
              margin: [0, 5, 0, 0]
            },
            {
              text: `${vm.$t('Shipping option')} ${vm.$t(
                el.shippingtype && el.shippingtype.includes('other')
                  ? shippinglist[el.shippingtype]
                    ? shippinglist[el.shippingtype][4]
                    : el.shippingtype
                  : el.shippingtype
              )}`,
              bold: true,
              margin: [0, 0, 0, 5]
            },
            ...(this.size == '5.7mm-detail'
              ? [
                  {
                    text: `${vm.$t('รายการสั่งซื้อ')}`,
                    bold: true
                  },
                  {
                    table: {
                      widths: ['auto', '*'],
                      body: [...formatproductdetail]
                    },
                    layout: {
                      defaultBorder: false,
                      paddingLeft: function(i, node) {
                        return 0
                      },
                      paddingRight: function(i, node) {
                        return 0
                      },
                      paddingTop: function(i, node) {
                        return 0
                      },
                      paddingBottom: function(i, node) {
                        return 0
                      }
                    }
                  },
                  {
                    table: {
                      widths: ['auto', '*'],
                      body: [
                        [
                          { text: `ยอดรวม`, lineHeight: 1 },
                          {
                            text: el.total,
                            alignment: 'right',

                            lineHeight: 1
                          }
                        ],
                        [
                          { text: `ค่าขนส่ง`, lineHeight: 1 },
                          {
                            text: el.shippingcharge,
                            alignment: 'right',

                            lineHeight: 1
                          }
                        ],
                        [
                          { text: `ส่วนลด`, lineHeight: 1 },
                          {
                            text: el.discount,
                            alignment: 'right',
                            lineHeight: 1
                          }
                        ],
                        [
                          {
                            text: `ยอดรวมทั้งหมด`,
                            lineHeight: 1
                          },
                          {
                            text: el.amount,
                            alignment: 'right',
                            lineHeight: 1
                          }
                        ]
                      ]
                    },
                    layout: {
                      defaultBorder: false,
                      paddingLeft: function(i, node) {
                        return 0
                      },
                      paddingRight: function(i, node) {
                        return 0
                      },
                      paddingTop: function(i, node) {
                        return 0
                      },
                      paddingBottom: function(i, node) {
                        return 0
                      }
                    }
                  },
                  {
                    text: [
                      {
                        text: `${vm.$t('Remark')}`
                      },
                      {
                        text:
                          el.remark != null &&
                          [
                            '148831989096546',
                            '1229692217050821',
                            '135565533158593',
                            '488563718210335',
                            '799590883441878'
                          ].includes(vm.selectedBot.pageid)
                            ? el.remark.split(';;')[0]
                            : el.remark
                      }
                    ],
                    lineHeight: 1
                  }
                ]
              : []),

            {
              text: '',
              lineHeight: 1,
              pageBreak: i + 1 == orders.length ? '' : 'after'
            }
          ]
        })
      } else if (['a5-onlyAddress'].includes(this.size)) {
        data = orders.map((el, i) => {
          var productdetail
          var payment = vm.$t('Credit card')
          if (el.payment == 'banktransfer' || el.payment == 'transfer') {
            payment = vm.$t('Bank Transfer')
          } else if (el.payment == 'qrcode') {
            payment = 'Qr Code'
          } else if (el.payment == 'fbpay') {
            payment = vm.$t('Mobile Banking')
          } else if (el.payment == 'cod') {
            payment = vm.$t('cod_charge')
          }
          var formatproductdetail = []
          try {
            productdetail = JSON.parse(el.productdetail)
            productdetail = productdetail.sort((a, b) => {
              return a.name.localeCompare(b.name)
            })
            formatproductdetail = productdetail.map((val, i) => {
              if (vm.showPrice) {
                return [
                  {
                    text: `${i + 1}. ${val.name} x ${val.quantity} (${val.option}) (${val.sku})`,
                    style: { fontSize: vm.regularsize },
                    bold: true
                  },
                  {
                    text: numeral(val.price).format('0,0.00'),
                    style: { fontSize: vm.regularsize },
                    alignment: 'right'
                  }
                ]
              } else {
                return [
                  {
                    text: `${i + 1}. ${val.name} x ${val.quantity} (${val.option}) ${
                      val.sku && val.sku !== '' ? `(${val.sku})` : ''
                    }`,
                    style: { fontSize: vm.regularsize },
                    bold: true
                  }
                ]
              }
            })
          } catch (error) {
            console.log(error)
            productdetail = []
            formatproductdetail = [{ text: el.productdetail }]
          }
          if (vm.showPrice) {
            formatproductdetail.push([
              {
                text: 'ยอดรวม',
                style: { fontSize: vm.regularsize },
                bold: true
              },
              {
                text: el.total,
                style: { fontSize: vm.regularsize },
                alignment: 'right'
              }
            ])
          }

          return [
            {
              margin: [0, 70, 0, 0],
              table: {
                widths: ['*'],
                heights: [60],
                body: [
                  [
                    {
                      text: [
                        { text: vm.$t('Sender') + '\n', style: 'header' },
                        {
                          text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                            vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                          } ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                          style: 'paragraph',
                          bold: true
                        }
                      ],
                      style: 'container',
                      lineHeight: 1
                    }
                  ]
                ]
              }
            },
            {
              margin: [0, 6, 0, 0],
              table: {
                widths: ['100%'],
                heights: [150],
                body: [
                  [
                    {
                      margin: [0, 0, 20, 0],
                      text: [
                        {
                          text: vm.$t('Receiver') + '\n',
                          style: { fontSize: 20, bold: true }
                        },
                        {
                          text: vm.noSpaceAndSpecial(el.nameaddress),
                          style: { fontSize: 18 },
                          bold: true
                        }
                      ],
                      style: 'container'
                    }
                  ]
                ]
              }
            },
            ...(el.payment != 'cod'
              ? []
              : [
                  {
                    pageBreak: i + 1 == orders.length ? '' : 'after',
                    margin: [0, 10, 0, 0],
                    table: {
                      widths: [200 + 175],
                      body: [[{}]]
                    },
                    layout: {
                      vLineWidth: function(i, node) {
                        return 0
                      },
                      hLineWidth: function(i, node) {
                        return 0
                      }
                    }
                  }
                ])
          ]
        })
      } else {
        data = orders.map((el, i) => {
          var productdetail
          var payment = vm.$t('Credit card')
          if (el.payment == 'banktransfer' || el.payment == 'transfer') {
            payment = vm.$t('Bank Transfer')
          } else if (el.payment == 'qrcode') {
            payment = 'Qr Code'
          } else if (el.payment == 'fbpay') {
            payment = vm.$t('Mobile Banking')
          } else if (el.payment == 'cod') {
            payment = vm.$t('cod_charge')
          }
          var formatproductdetail = []
          try {
            productdetail = JSON.parse(el.productdetail)
            productdetail = productdetail.sort((a, b) => {
              return a.name.localeCompare(b.name)
            })
            formatproductdetail = productdetail.map((val, i) => {
              if (vm.showPrice) {
                return [
                  {
                    text: `${i + 1}. ${val.name} x ${val.quantity} (${val.option}) ${
                      val.sku && val.sku !== '' ? `(${val.sku})` : ''
                    }`,
                    style: { fontSize: vm.regularsize },
                    bold: true
                  },
                  {
                    text: numeral(val.price).format('0,0.00'),
                    style: { fontSize: vm.regularsize },
                    alignment: 'right'
                  }
                ]
              } else {
                return [
                  {
                    text:
                      i +
                      1 +
                      '. ' +
                      val.name +
                      ` x ${val.quantity} (${val.option}) ${
                        val.sku && val.sku !== '' ? `(${val.sku})` : ''
                      }`,
                    style: { fontSize: vm.regularsize },
                    bold: true
                  }
                ]
              }
            })
          } catch (error) {
            console.log(error)
            productdetail = []
            formatproductdetail = [{ text: el.productdetail }]
          }
          if (vm.showPrice) {
            formatproductdetail.push([
              {
                text: 'ยอดรวม',
                style: { fontSize: vm.regularsize },
                bold: true
              },
              {
                text: el.total,
                style: { fontSize: vm.regularsize },
                alignment: 'right'
              }
            ])
          }

          return [
            {
              // width: 225,
              table: {
                widths: ['*'],
                heights: [60],
                body: [
                  [
                    {
                      text: [
                        { text: vm.$t('Sender') + '\n', style: 'header' },
                        {
                          text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                            vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                          } ${vm.noSpaceAndSpecial(vm.profile.pageaddress)}`,
                          style: 'paragraph',
                          bold: true
                        }
                      ],
                      style: 'container',
                      lineHeight: 1
                    }
                  ]
                ]
              }
            },
            {
              margin: [0, 6, 0, 0],
              table: {
                widths: ['100%'],
                heights: [60],
                body: [
                  [
                    {
                      margin: [0, 0, 10, 0],
                      text: [
                        { text: vm.$t('Receiver') + '\n', style: 'header' },
                        {
                          text: vm.noSpaceAndSpecial(el.nameaddress),
                          style: 'paragraph',
                          bold: true
                        }
                      ],
                      style: 'container'
                    }
                  ]
                ]
              }
            },
            {
              margin: [0, 10, 0, 0],
              columns: [
                {
                  text: [
                    '148831989096546',
                    '1229692217050821',
                    '135565533158593',
                    '488563718210335',
                    '799590883441878'
                  ].includes(vm.selectedBot.pageid)
                    ? vm.$t('ใบกำกับภาษี/ใบเสร็จรับเงิน')
                    : vm.$t('Receipt'),
                  style: 'receipt'
                }
              ]
            },
            {
              table: {
                widths: [50, 162, 93, 55],
                lineHeight: 0.5,
                body: [
                  [
                    {
                      text: vm.$t('Order No:'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: el.id,
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: vm.$t('Order Date: '),
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: dayjs(el.timestamp).format('DD/MM/YYYY'),
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    }
                  ]
                ]
              },
              layout: {
                hLineColor: function(i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineColor: function(i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineWidth: function(i, node) {
                  return 0
                },
                hLineWidth: function(i, node) {
                  return 0
                }
              }
            },
            {
              table: {
                widths: [200, 175],
                body: [
                  [
                    {
                      text: vm.$t('Shipping option'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      columns: [
                        {
                          text: vm.$t(
                            el.shippingtype && el.shippingtype.includes('other')
                              ? shippinglist[el.shippingtype]
                                ? shippinglist[el.shippingtype][4]
                                : el.shippingtype
                              : el.shippingtype
                          ),
                          width: '*',
                          style: {
                            alignment: 'right',
                            fontSize: vm.regularsize
                          },
                          margin: [0, 0, 10, 0],
                          bold: true
                        },
                        {
                          image: shippingtypeimg[el.shippingtype]
                            ? shippingtypeimg[el.shippingtype]
                            : shippingtypeimg['other_charge'],
                          width: 40,
                          style: {
                            alignment: 'right',
                            fontSize: vm.regularsize - 3
                          }
                        }
                      ]
                    }
                  ],
                  [
                    {
                      text: vm.$t('Payment Method'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text: payment,
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    }
                  ],
                  [
                    {
                      text: vm.$t('Remark'),
                      style: { fontSize: vm.regularsize },
                      bold: true
                    },
                    {
                      text:
                        el.remark != null &&
                        [
                          '148831989096546',
                          '1229692217050821',
                          '135565533158593',
                          '488563718210335',
                          '799590883441878'
                        ].includes(vm.selectedBot.pageid)
                          ? el.remark.split(';;')[0]
                          : el.remark,
                      style: { alignment: 'right', fontSize: vm.regularsize },
                      bold: true
                    }
                  ]
                ]
              },
              layout: {
                hLineColor: function(i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineColor: function(i, node) {
                  return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                },
                vLineWidth: function(i, node) {
                  return 0
                },
                hLineWidth: function(i, node) {
                  return 0
                }
              }
            },
            {
              text: vm.$t('Product Detail'),
              margin: [0, 5, 0, 2],
              style: {
                bold: true,
                fontSize: vm.headersize
              }
            },
            {
              table: {
                widths: vm.showPrice ? [300, 70] : [370],
                body: formatproductdetail
              },
              // layout: {
              //   hLineColor: function(i, node) {
              //     return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              //   },
              //   vLineColor: function(i, node) {
              //     return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
              //   }
              // },
              pageBreak: i + 1 == orders.length || el.payment == 'cod' ? '' : 'after'
            },
            ...(el.payment != 'cod'
              ? []
              : [
                  {
                    pageBreak: i + 1 == orders.length ? '' : 'after',
                    margin: [0, 10, 0, 0],
                    table: {
                      widths: [200 + 175],
                      body: [
                        // [vm.$t('Subtotal') + ':', { text: '฿' + el.total, style: { alignment: 'right' } }],
                        [
                          // { text: , style: { fontSize: vm.regularsize } },
                          {
                            text: vm.$t('Total price') + ': ' + '฿' + el.amount,
                            style: {
                              alignment: 'right',
                              fontSize: vm.regularsize + 10
                            },
                            bold: true
                          }
                        ]
                      ]
                    },
                    layout: {
                      vLineWidth: function(i, node) {
                        return 0
                      },
                      hLineWidth: function(i, node) {
                        return 0
                      }
                    }
                  }
                ])
          ]
        })
      }

      return data
    },
    getDocumentFormat(size) {
      var dpi = 72
      switch (size) {
        case 'billing':
          return {
            pageSize: {
              width: 2.28 * dpi,
              height: 'auto'
            },
            pageMargins: [10, 20, 20, 20]
          }
        case 'new-a5':
          return {
            pageSize: 'A5',
            pageMargins: [10, 15, 10, 15]
          }
        case 'a4':
          return {
            pageSize: 'A4',
            pageMargins: [10, 15, 10, 15]
          }
        case '5.7mm':
        case '5.7mm-detail':
          return {
            pageSize: {
              width: 2.24 * dpi,
              height: 'auto'
            },
            pageMargins: [10, 15, 10, 15]
          }
        case 'paperrang':
        case 'paperrang-detail':
          return {
            pageSize: {
              width: 2.24 * dpi,
              height: 'auto'
            },
            pageMargins: [10, 15, 10, 15]
          }
        case 'a5-onlyAddress':
          return {
            pageSize: null,
            pageMargins: null,
            pageOrientation: 'landscape'
          }
        default:
          return {
            pageSize: null,
            pageMargins: null
          }
      }
    },
    async printPDF(orders, pageSetting = {}, page) {
      var data = await this.formatTemplate(orders, page)
      var dd = {
        content: [data],
        pageSize: pageSetting.pageSize || 'A5',
        pageMargins: pageSetting.pageMargins || [15, 15, 15, 15],
        pageOrientation: pageSetting.pageOrientation || 'portrait',
        styles: {
          header: {
            fontSize: this.headersize,
            // color: '#ff5656',
            bold: true
          },
          paragraph: {
            fontWeight: 200,
            fontSize: this.regularsize
          },
          container: {
            margin: [2, 2, 2, 2]
          },
          receipt: {
            fontSize: this.headersize,
            // color: '#ff5656',
            bold: true
          }
        },
        defaultStyle: {
          font: 'THSarabunNew'
        }
      }
      this.loading = false
      pdfMake.createPdf(dd).open()
    },

    getBase64ImageFromURL(url) {
      if (url) {
        return new Promise((resolve, reject) => {
          var img = new Image()
          console.log(img)
          img.setAttribute('crossOrigin', 'anonymous')
          img.onload = () => {
            var canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            var dataURL = canvas.toDataURL('image/png')
            resolve({
              image: dataURL,
              width: 100,
              margin: [0, 10, 0, 0]
            })
          }
          console.log(img)
          img.onerror = error => {
            resolve({
              text: '',
              margin: [0, 10, 0, 0]
            })
            reject(error)
          }
          img.src = url + '?not-from-cache-please'
        })
      } else {
        return {
          text: '',
          margin: [0, 15, 0, 0]
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ecommerce/PrintAllCovers.js